import useSWR, { SWRConfiguration } from "swr";
import { getWithAuth } from "utils/dataUtils";
import { useAppSelector } from "store";

type SiteModelInfoResponse = {
  siteModelImageUrl: string | null;
  siteModelHasRoofPlanes: boolean;
};

const useSiteModelInfo = (
  prospectId?: string,
  options?: SWRConfiguration,
  minimumValidDate?: string
) => {
  const cognitoToken = useAppSelector(
    (state) => state.auth.cognitoToken?.token
  );

  return useSWR(
    prospectId && cognitoToken
      ? [
          `/prospect/${prospectId}/siteModelInfo`,
          cognitoToken,
          minimumValidDate,
        ]
      : null,
    ([path, cognitoToken, minimumValidDate]) => {
      if (!cognitoToken) return;
      const url = minimumValidDate
        ? `${path}?minimumValidDate=${encodeURIComponent(minimumValidDate)}`
        : path;
      return getWithAuth<SiteModelInfoResponse>([
        "Get Site Model Info",
        url,
        cognitoToken,
      ]);
    },
    options
  );
};

export { useSiteModelInfo };
export type { SiteModelInfoResponse };
